import React from 'react';
import { PageNavigationTemplate } from 'themes/layouts';

function PageNavigation(props) {
    return <PageNavigationTemplate {...props} />;
}

export default PageNavigation;
